export const Routes = {

    // authen
    Signin: { path: "/login-in" },
    Signup: { path: "/sign-up" },
    ForgotPassword: { path: "/forgot-password" },
    ResetPassword: { path: "/reset-password" },
    ServerError: { path: "/server-error" },

    // trang chủ
    Overview: { path: "/" },
    ShipOverview: { path: "/ship" },

    // SHIP
    CartWaiting: { path: "/ship/cart/waiting" },
    CartDone: { path: "/ship/cart/done" },
    TicketWaiting: { path: "/ship/ticket/waiting" },
    TicketDone: { path: "/ship/ticket/done" },
    Banner: { path: "/banner" },
    BannerGroup: { path: "/banner-group" },

    MBDoisoat: { path: "/wip/mb-doisoat" },

    NotFound: { path: '/not-found' }
};